import * as salesforceRequests from "./salesforce-requests";
import * as cpqUtils from "./cpq";
export default {
    requests: salesforceRequests,
    utils: cpqUtils
};
